module.exports = __webpack_public_path__ + "static/img/user.9aa1fe61.svg";